import { FC } from 'react'

import { getMonthAndYear } from '../../helpers/formatting'

interface Props {
  date: Date
}

const MaturityDate: FC<Props> = ({ date }) => {
  const { year, month } = getMonthAndYear(date)
  return (
    <>
      {month < 10 && <span>0</span>}
      {month}/{year % 100}
    </>
  )
}

export default MaturityDate
